/* istanbul ignore file */
import { object, string, ObjectSchema, number } from 'yup'

export interface IChangedRequestFormSchema {
  changesRequested: string
  recipientId: string
  stepNumber: number
}

export const changedRequestValidationSchema = object().shape({
  changesRequested: string().required('Communication preference letter is a required field'),
  recipientId: string().required('Communication preference letter is a required field'),
  stepNumber: number().required('Communication preference letter is a required field'),
}) as ObjectSchema<IChangedRequestFormSchema, any, any, ''>
